<!--
@Author: Calvin Green <calvin>
@Date:   2022-04-07T08:39:01+02:00
@Email:  calvin@diversitude.com
@Last modified by:   calvin
@Last modified time: 2022-08-29T09:31:17+02:00
@Copyright: Diversitude 2022
-->


<template>
    <b-row>
        <b-col cols="12">
            <b-overlay :show="!ready" no-wrap></b-overlay>
        </b-col>
        <b-col cols="12" v-if="ready">
            <div v-if="action == 'list'">
                <div style="margin-top: 10px; margin-bottom: 15px;">
                    <b-button variant="primary" @click="setAction('add')">Add Supplier</b-button>&nbsp;
                    <b-button variant="success" @click="exportToExcel('suppliersTable')">Export to Excel</b-button>
                </div>
                <SuppliersTable @editSupplier="editSupplier"></SuppliersTable>
            </div>
            <div v-if="action == 'view'">
                <div style="margin-top: 10px; margin-bottom: 15px;">
                    <b-button variant="primary" @click="setAction('list')">Back</b-button>
                </div>
                <ViewSupplier :editSupplierId="editSupplierId"></ViewSupplier>
            </div>
            <div v-if="action == 'add'">
                <div style="margin-top: 10px; margin-bottom: 15px;">
                    <b-button variant="primary" @click="setAction('list')">Back</b-button>
                </div>
                <AddSupplierForm></AddSupplierForm>
            </div>
        </b-col>
    </b-row>
</template>

<script>
import SuppliersTable from './suppliersTable.vue'
import AddSupplierForm from './addSupplierForm.vue'
import ViewSupplier from './viewSupplier.vue'
import { facilityAdminState, facilityAdminMethods } from '@/state/helpers'
import _ from 'lodash'
export default {
    data:() => ({
        action: 'list',
        editSupplierId: -1,
        ready: false
    }),
    components: {
        SuppliersTable,
        AddSupplierForm,
        ViewSupplier
    },
    computed:{
        ...facilityAdminState,
    },
    methods:{
        ...facilityAdminMethods,
        setAction(action) {
            this.action = action;
        },
        editSupplier(id) {
            this.editSupplierId = id;
            this.action = "view";
        },
        exportToExcel(id) {
            /* eslint-disable */
            return webix.toExcel($$(id), {
                ignore: { "actions": true },
                filename: _.uniqueId("suppliersExport_"), // for filename
                name: "Suppliers" // for sheet name
            });
            /* eslint-enable */            
        }
    },
    mounted(){
        if (this.client_suppliers.length == 0) {
            this.loadClientSuppliers()
            .then(()=>{
                this.ready = true;
            });
        } else {
            this.ready = true;
        }
        if (this.supplier_types.length == 0) {
            this.loadSupplierTypes();
        }
    },
}
</script>

<style>

</style>
